import React, { useEffect, useState } from 'react';
import { BUSINESS } from '@/lib/businessConfig';
import Button from './Button';

const CLICKED_KEY = 'ik_booking_clicked';
const SHOWN_KEY = 'ik_review_prompt_shown';

// Shows once per session after a Fresha booking click: either when the visitor
// returns to the tab, or 30s after the click — whichever comes first.
export default function ReviewRequestOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timer = null;
    const show = () => {
      if (sessionStorage.getItem(SHOWN_KEY)) return;
      sessionStorage.setItem(SHOWN_KEY, '1');
      setOpen(true);
    };
    const arm = () => {
      if (sessionStorage.getItem(SHOWN_KEY)) return;
      sessionStorage.setItem(CLICKED_KEY, '1');
      if (!timer) timer = setTimeout(show, 30000);
    };
    const onClick = (e) => {
      if (e.target?.closest?.('a[href*="fresha.com"]')) arm();
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible' && sessionStorage.getItem(CLICKED_KEY)) show();
    };
    if (sessionStorage.getItem(CLICKED_KEY)) arm();
    document.addEventListener('click', onClick, true);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('visibilitychange', onVisible);
      if (timer) clearTimeout(timer);
    };
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-warm-black/60 p-4" onClick={() => setOpen(false)}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="review-prompt-title"
        className="relative w-full max-w-[460px] rounded-card-l bg-warm-black text-cream p-8 md:p-10 text-center shadow-card animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={() => setOpen(false)} aria-label="Close" className="absolute top-4 right-5 text-cream/60 hover:text-gold-light text-[22px] leading-none">×</button>
        <div className="text-[28px] text-gold-light opacity-60 mb-3">✦</div>
        <h2 id="review-prompt-title" className="font-serif text-[30px] leading-[1.1] font-medium tracking-[-1px] mb-3">
          Loved your visit?
        </h2>
        <p className="text-body text-cream/75 mb-7">Your review helps others find us.</p>
        <Button variant="gold" href={BUSINESS.googleReviewUrl} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>
          Leave a Google review <span>→</span>
        </Button>
      </div>
    </div>
  );
}